export const back = function(){
      window.history.back();  
}
 